(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sun365-eu-legal-guarantee"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('sun365-eu-notice')) {
    customElements.define('sun365-eu-notice', class extends HTMLElement {
      connectedCallback() {
        if (this.abort) return;
        this.dialog = this.querySelector('dialog');
        this.trigger = this.querySelector('[data-eu-notice-open]');
        if (!this.dialog || !this.trigger || !this.dialog.showModal) return;
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        this.trigger.addEventListener('click', (event) => {
          if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
          event.preventDefault();
          this.dialog.showModal();
          this.dialog.scrollTop = 0;
          document.documentElement.classList.add('sun365-eu-notice-open');
        }, options);
        this.querySelector('[data-eu-notice-close]').addEventListener('click', () => this.dialog.close(), options);
        this.querySelector('[data-eu-notice-text]').addEventListener('click', () => {
          const heading = this.querySelector('.sun365-eu-notice__text h3');
          const header = this.querySelector('.sun365-eu-notice__header');
          const top = this.dialog.scrollTop + heading.getBoundingClientRect().top - this.dialog.getBoundingClientRect().top - header.getBoundingClientRect().height - 20;
          this.dialog.scrollTo({ top, behavior: 'instant' });
          heading.focus({ preventScroll: true });
        }, options);
        this.dialog.addEventListener('close', () => {
          document.documentElement.classList.remove('sun365-eu-notice-open');
          if (this.trigger.isConnected) this.trigger.focus({ preventScroll: true });
        }, options);
        this.dialog.addEventListener('click', (event) => {
          if (event.target !== this.dialog) return;
          const rect = this.dialog.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
        }, options);
      }
      disconnectedCallback() {
        if (this.dialog && this.dialog.open) {
          this.dialog.close();
          document.documentElement.classList.remove('sun365-eu-notice-open');
        }
        if (this.abort) this.abort.abort();
        this.abort = null;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sun365-samduo-halloween-countdown"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('sun365-halloween-countdown')) {
    customElements.define('sun365-halloween-countdown', class extends HTMLElement {
      connectedCallback() {
        clearInterval(this.timer);
        this.end = Date.parse(this.dataset.end);
        this.timerRow = this.querySelector('[role="timer"]');
        this.units = ['days', 'hours', 'minutes', 'seconds'].map(unit => this.querySelector(`[data-${unit}]`));
        if (!Number.isFinite(this.end) || !this.timerRow || this.units.some(unit => !unit)) {
          this.hidden = true;
          return;
        }
        const update = () => {
          const remaining = Math.ceil((this.end - Date.now()) / 1000);
          if (remaining <= 0) {
            this.hidden = true;
            clearInterval(this.timer);
            return false;
          }
          const values = [Math.floor(remaining / 86400), Math.floor(remaining % 86400 / 3600), Math.floor(remaining % 3600 / 60), remaining % 60];
          values.forEach((value, index) => { this.units[index].textContent = String(value).padStart(2, '0'); });
          this.timerRow.hidden = false;
          this.hidden = false;
          return true;
        };
        if (update()) this.timer = setInterval(update, 1000);
      }
      disconnectedCallback() { clearInterval(this.timer); }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
